// extracted by mini-css-extract-plugin
export default {"status-card":"StatusCard_status-card__ReYWY FDChatOverview_card__MHz1c","label":"StatusCard_label__5pTA9","preview-interview-link":"StatusCard_preview-interview-link__BbiWO"};